import styled from 'styled-components'
import IconButton from '@material-ui/core/IconButton'

const CloseButton = styled(IconButton)`
  position: absolute;
  top: 8px;
  right: 8px;
`

export default CloseButton
